module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: "userInfo"
      },
      "active-class": "bianlan"
    }
  }, [_vm._v("Personal Information"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: "myDesign"
      },
      "active-class": "bianlan"
    }
  }, [_vm._v("My Design"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: "myOrder"
      },
      "active-class": "bianlan"
    }
  }, [_vm._v("My Order"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: "favorite"
      },
      "active-class": "bianlan"
    }
  }, [_vm._v("Favorites"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: "comment"
      },
      "active-class": "bianlan"
    }
  }, [_vm._v("Browsing History"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: "history"
      },
      "active-class": "bianlan"
    }
  }, [_vm._v("Commented"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b450f2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user_left.vue
// module id = 535
// module chunks = 63